import { makeStyles } from '@material-ui/core';
import CustomLogo from './logo/konfio-logo-app.png';

const useStyles = makeStyles({
  image: {
    width: 'auto',
    height: 42,
  },
});

const LogoIcon = () => {
  const classes = useStyles();
  return (
    <img alt="Konfio Icon Logo" className={classes.image} src={CustomLogo} />
  );
};

export default LogoIcon;
